import React, { useState, useEffect } from 'react';
import ONRC_eKYC_Details from './ONRC_eKYC_Details';

import CircularProgress from '@mui/material/CircularProgress';

const ONRC_eKYC = () => {
    const [data, setData] = useState(null);
    const [detailsData, setDetailsData] = useState(null);
    const [loading, setLoading] = useState(false);
  
    useEffect(() => {
        fetch(`${process.env.REACT_APP_URL_SIDE}/api/ONRC/onrc-ekyc`)
            .then(response => response.json())
            .then(data => setData(data))
            .catch(error => console.error('Error:', error));
    }, []);

    const handleDetailsED = (home_state_code, sale_state_code) => {
        setLoading(true);
        fetch(`${process.env.REACT_APP_URL_SIDE}/api/ONRC/onrc-ekyc-details?home_state_code=${home_state_code}&sale_state_code=${sale_state_code}`)
            .then(response => response.json())
            .then(htmlData => {
                setDetailsData(htmlData);
                setLoading(false);
                setTimeout(() => {
                    const detailsED = document.getElementById('detailsED');
                    if (detailsED) {
                        detailsED.scrollIntoView({ behavior: 'smooth' });
                    }
                }, 500);
            })
            .catch(error => {
                console.error('Error:', error);
                setLoading(false);
            });
        return false;
    };

    const PrintPDF = (id, title) => {
        if (!data || !data.rows || data.rows.length === 0) {
            alert("No data available to print.");
            return;
        }
        window.print();
    };

    if (!data) {
        return (
            <div className="mainhead" align="center">
                Loading...
            </div>
        );
    }

    const { stateCode, stateName, rows } = data;
  
    if (!rows || rows.length === 0) {
        return (
            <div className="mainhead" align="center">
                Details not found
            </div>
        );
    }

    let impds_in = 0;
    let impds_in_todays = 0;
    let impds_out = 0;
    let impds_out_todays = 0;
    let kyc_in_face = 0;
    let kyc_out_face = 0;
  
    rows.forEach(row => {
        impds_in += row.impds_in || 0;
        impds_in_todays += row.impds_in_todays || 0;
        impds_out += row.impds_out || 0;
        impds_out_todays += row.impds_out_todays || 0;
        kyc_in_face += row.kyc_in_face || 0;
        kyc_out_face += row.kyc_out_face || 0;
    });

    return (
        <div>
            <style>{`
                .stickytop1 { position: sticky; top: 0px; background: #f1872bff; color: black; font-weight: bold; z-index: 10; }
                .stickytop2 { position: sticky; top: 31px; background: #f1872bff; color: black; font-weight: bold; z-index: 10; }
                .stickytop3 { position: sticky; top: 77px; background: #f1872bff; color: black; font-weight: bold; z-index: 10; }
                @media print {
                    body * { visibility: hidden; }
                    #onrcreport, #onrcreport * { visibility: visible; }
                    #onrcreport { position: absolute; left: 0; top: 0; width: 100%; }
                    .hideprit { display: none !important; }
                    #loading, #detailsED { display: none !important; }
                    .stickytop1 { position: relative; top: auto; }
                    .stickytop2 { position: relative; top: auto; }
                    .stickytop3 { position: relative; top: auto; }
                }
            `}</style>
            <div id="onrcreport">
                <table width="80%" align="center" border="1" style={{borderCollapse: 'collapse',marginTop:"15px"}}>
                    <tbody>
                        <tr className="tableheader stickytop1">
                            <th colSpan="8">ONRC EKYC Status</th>
                        </tr>
                        <tr className="tableheader stickytop2">
                            <th rowSpan="2">Sl.No</th>
                            <th rowSpan="2">State</th>
                            <th colSpan="3">Other State eKYC<br/>in {stateName}</th>
                            <th colSpan="3">{stateName} eKYC<br/>in Other State</th>
                        </tr>
                        <tr className="tableheader stickytop3">
                            <td>Today</td>
                            <td>Total</td>
                            <td>Face</td>
                            <td>Today</td>
                            <td>Total</td>
                            <td>Face</td>
                        </tr>
                        {rows.map((row, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{row.state_name_en}</td>
                                <td align="right">{row.impds_in_todays || 0}</td>
                                <td align="right">{row.impds_in || 0}</td>
                                <td align="right">{row.kyc_in_face || 0}</td>
                                <td align="right">{row.impds_out_todays || 0}</td>
                                <td align="right">
                                    {row.impds_out > 0 ? (
                                        <a
                                            href="#"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                handleDetailsED(stateCode, row.home_state_code);
                                            }}
                                            style={{cursor: 'pointer', textDecoration: 'underline', color: 'black'}}
                                        >
                                            {row.impds_out}
                                        </a>
                                    ) : (
                                        row.impds_out || 0
                                    )}
                                </td>
                                <td align="right">{row.kyc_out_face || 0}</td>
                            </tr>
                        ))}
                        <tr className="tableheader">
                            <td colSpan="2" align="center">Total</td>
                            <td align="right">{impds_in_todays}</td>
                            <td align="right">{impds_in}</td>
                            <td align="right">{kyc_in_face}</td>
                            <td align="right">{impds_out_todays}</td>
                            <td align="right">{impds_out}</td>
                            <td align="right">{kyc_out_face}</td>
                        </tr>
                        <tr className="hideprit">
                            <td colSpan="8" align="center">
                                <input
                                    type="button"
                                    value="PDF"
                                    className="button button2"
                                    onClick={() => PrintPDF('onrcreport', 'ONRC EKYC Status')}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <br />
             <div align="center" id="loading" style={{display: loading ? 'block' : 'none'}}>
                <CircularProgress style={{ margin: '20px' }} />
            </div>
            <br />
            <div id="detailsED">
                {detailsData && <ONRC_eKYC_Details data={detailsData} />}
            </div>
        </div>
    );
};

export default ONRC_eKYC;

